import React, { Fragment } from "react";
import { offeringConfig } from "../offering_config";

import { OfferingDetailsMultiPass } from "../template_offering_details_multipass";
import { Spacer } from "../spacer";
import { Text } from "../text";
import { TextLink } from "../text_link";
import { useUrbanplaceAnalytics } from "./urbanplace_analytics";
import { generalInfo, partnerConfig } from "./urbanplace_partner_config";
import { lazyWithRetry } from "../../core/lazy_with_retry";

const Theme = lazyWithRetry(() => import("./urbanplace_theme"));

const faqs = [
  {
    question: "Can I share my multi passes with other people?",
    answer: "The passes are for personal use only and are not transferable.",
  },

  {
    question: "Can I use the meeting rooms?",
    answer: (
      <Text>
        Yes, the meeting rooms are charged at an hourly rate.{" "}
        <TextLink
          href={`/offerings/${offeringConfig.Urbanplace.slugConfig.meetingRooms}`}
        >
          You can book a meeting room here.
        </TextLink>
      </Text>
    ),
  },

  {
    question: "Can I use the printer?",
    answer:
      "Yes, please get in touch with the community manager and we will assist you.",
  },

  {
    question: "Can I meet with clients or bring a guest using my passes?",
    answer:
      "Your day pass is for personal use only and doesn’t cover guests. You may purchase additional day passes for each of your guests.",
  },

  {
    question: "Where can I keep and heat my lunch?",
    answer:
      "The kitchen, refrigerator and microwave is available for your use.",
  },

  {
    question: "Do you offer coffee or tea?",
    answer: "Yes, coffee and tea are complimentary.",
  },

  {
    question: "Do I need to book in advance to use my Multi-Pass?",
    answer: (
      <Text>
        Yes. You will need to book ahead of time. When possible, we will
        accommodate walk-ins according to availability.{" "}
        <TextLink href="https://partners.flexspace.ai/portal/urbanplace">
          Manage your bookings using the portal.
        </TextLink>
      </Text>
    ),
  },

  {
    question: "Can I cancel my day pass purchase?",
    answer: "The Multi Pass is non-refundable.",
  },

  {
    question: "Can I change the date of my day pass booking?",
    answer: (
      <Text>
        Yes. you can{" "}
        <TextLink href="https://partners.flexspace.ai/portal/urbanplace">
          manage your bookings using the portal.
        </TextLink>
      </Text>
    ),
  },

  {
    question: "How do I login to the portal?",
    answer:
      "If you haven’t already done so, please click on the sign up and follow the prompts. Be sure to " +
      "use the same email address you used when purchasing your multi pass. Once you have " +
      "created your account, you can login to manage your bookings.",
  },
];

export function OfferingUrbanplaceDeskMultiPass() {
  useUrbanplaceAnalytics();

  return (
    <Fragment>
      <Theme />
      <OfferingDetailsMultiPass
        showAddress={false}
        showDirections
        partnerConfig={partnerConfig}
        data={{
          description: (
            <Fragment>
              <Text>
                The UP DAILY DESK multi-pass is perfect when you want to come in
                a couple of times a week. Purchase your day passes in bulk at a
                lower price without a long term commitment.
              </Text>
              <Spacer size={8} />
              <Text>
                Enjoy a dedicated desk with membership benefits for a few days a
                week.
              </Text>
            </Fragment>
          ),
          faqs: faqs,
          generalInfo,
        }}
      />
    </Fragment>
  );
}
